/**
 * Convert array of objects to CSV string
 */
export function arrayToCSV(data: unknown[]): string {
  if (data.length === 0) {
    return '';
  }

  // Get headers from first object
  const headers = Object.keys(data[0] as Record<string, unknown>);
  
  // Create CSV header row
  const headerRow = headers.map(escapeCSV).join(',');
  
  // Create CSV data rows
  const dataRows = data.map((row) => {
    const record = row as Record<string, unknown>;
    return headers.map((header) => escapeCSV(String(record[header] ?? ''))).join(',');
  });

  return [headerRow, ...dataRows].join('\n');
}

/**
 * Escape CSV field value
 */
function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * Download CSV file
 */
export function downloadCSV(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

